export function isConfirmed(value?: string | null): boolean {
  return value === 'true' || value === 'True' || value === 'S'
}

export function needsPhoneConfirmation(phone?: string | null): boolean {
  return !isConfirmed(phone)
}

export function needsEmailConfirmation(email?: string | null): boolean {
  return !isConfirmed(email)
}
